<div class="container-fluid">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-4 col-xl-4">
      <div class="home-details"><h5 class="home-title">Entity Details</h5></div>
    </div>
    <div class="col-12 col-md-8 col-lg-6 col-xl-6">
      <div class="dashboard-btn dashboard-manage">
        <a (click)="goBack()"><button class="btn btn-primary btn-dashboard">Back</button></a>
        <a [routerLink]="['/entities/edit-entity/', entityId]">
          <button class="btn btn-primary btn-dashboard">Edit Details</button>
        </a>
      </div>
    </div>
  </div>
  <div class="row section1">
    <div class="col-12 col-md-6 col-lg-5 col-xl-5">
      <div class="applicants-details details1 pt-4">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Entity Name</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{entity.entityName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Is person ?</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{entity.in_person}}</p></div>
        </div>
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Is followable ?</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{entity.allow_bhakt}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>ID</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{entity.id}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Category Name</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            @if (entity.category) {
              <p>{{entity.category.categoryName}}</p>
            }
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Created At</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{createdAt}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
            <p>Image</p>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <img [src]="entity.image" alt="Profile Image" width="128px" class="img-fluid">
          </div>
        </div>
        <hr class="border2"> <br>
        <h6 class="job-title">Review Score Details</h6>
        @for (rating of ratings; track rating) {
          <div>
            <hr class="border2">
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <p>{{rating.item.parameter.fieldName}}</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{rating.score}}%</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-5 col-xl-5">
      <div class="applicants-details details1 pt-4 mb-3 pb-0">
        <h6 class="job-title">Informative Data</h6>
        <hr class="border2">
        @for (param of entity?.infoData?.informativeParameters; track param) {
          <div>
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <h6 class="job-title subtitle" style="color: orange">{{param.fieldName}}</h6>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                @if (param.value != null) {
                  <p [innerHTML]="param.value"></p>
                }
                @if (param.value == null) {
                  <p>N/A</p>
                }
              </div>
            </div>
          </div>
        }
        <div class="row"></div>
      </div>
      <div class="applicants-details details1 pt-4 mb-3 pb-0">
        <h6 class="job-title">Subjective Data</h6>
        <hr class="border2">
        @for (s of entity?.subjectiveData?.value; track s) {
          <div>
            <h6 class="job-title subtitle" style="color: orange">{{s.field.fieldName}}</h6>
            <div class="row">
              <div class="col-12">
                @if (s.value != null) {
                  <p [innerHTML]="s.value"></p>
                }
                @if (s.value == null) {
                  <p>Null</p>
                }
              </div>
            </div>
          </div>
        }
        <hr class="border2">
      </div>
    </div>
  </div>
</div>

<!--<mat-card class="diff-card">-->
<!--  <mat-card-header>-->
<!--    <div mat-card-avatar class="diff-card-avatar"></div>-->
<!--    <mat-card-title class="diff-card-title">Title</mat-card-title>-->
<!--    <mat-card-subtitle class="diff-card-subtitle">Subtitle</mat-card-subtitle>-->
<!--  </mat-card-header>-->
<!--  <mat-card-content>-->
<!--    <p class="diff-card-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>-->
<!--    <div class="diff-card-diff">-->
<!--      <p class="diff-card-diff-title">Differences:</p>-->
<!--      <ul>-->
<!--        <li class="diff-card-diff-item">Difference 1</li>-->
<!--        <li class="diff-card-diff-item">Difference 2</li>-->
<!--        <li class="diff-card-diff-item">Difference 3</li>-->
<!--      </ul>-->
<!--    </div>-->
<!--  </mat-card-content>-->
<!--</mat-card>-->
